import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import SettingsProvider from './contexts/Settings';
import { ApiProvider } from './contexts/Api';
import { CookiesProvider, useCookies } from 'react-cookie';
import { AuthProvider } from './contexts/AuthContext';
function ConditionalApiProvider({ children }) {
  const [cookies] = useCookies(['tokenProf']);

  // tokenProf yoxlanılır
  if (!cookies.tokenProf) {
    console.warn('ApiProvider işə düşmədi, çünki tokenProf mövcud deyil.');
    return children; // ApiProvider olmadan App göstərilir
  }

  return <ApiProvider>{children}</ApiProvider>;
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CookiesProvider>
    <BrowserRouter>
      <SettingsProvider>
        <AuthProvider>
          <ConditionalApiProvider>
            <App />
          </ConditionalApiProvider>
        </AuthProvider>
      </SettingsProvider>
    </BrowserRouter>
  </CookiesProvider>
);

